import { type CSSProperties, type FC, type PropsWithChildren } from 'react';

export const LEADING_SLOT_SIZE = 26;

export const centeredSlotIconStyle: CSSProperties = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
};

interface ListLeadingSlotProps {
  testId?: string;
}

const ListLeadingSlot: FC<PropsWithChildren<ListLeadingSlotProps>> = ({ children, testId }) => (
  <span
    className="relative dib v-mid flex-none mr2"
    style={{ width: LEADING_SLOT_SIZE, height: LEADING_SLOT_SIZE }}
    data-testid={testId}
  >
    {children}
  </span>
);

export default ListLeadingSlot;
